import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { EditorContentStateQuery } from './EditorContentStateQuery.graphql';
import type {
	EditorContentStateQuery as EditorContentStateQueryType,
	EditorContentStateQueryVariables,
} from './__types__/EditorContentStateQuery';

type PreloadEditorContentStateParams = {
	contentId: any;
	useCache: boolean;
	shouldGetDraftVersion: boolean;
};

export function preloadEditorContentState({
	contentId,
	useCache,
	shouldGetDraftVersion,
}: PreloadEditorContentStateParams) {
	return query<EditorContentStateQueryType, EditorContentStateQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: EditorContentStateQuery,
		variables: {
			contentId,
			isDraft: shouldGetDraftVersion,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
